/* requires:
polyfill.js
*/

const findCourseForm = {
  init: function (formId) {
    const theForm = document.getElementById(formId);

    this.validateOnBlur(theForm);
    this.populateCategories(theForm);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type="submit"]');
    submitBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const isFormValid = findCourseForm.isFormValid(theForm);
        if (!isFormValid) {
          alert('Please select your state and choose a topic.');
          return false;
        } else {
          window.location = theForm.action;
        }
      },
      true
    );
  },

  populateCategories: function (theForm) {
    const categorySelect = theForm.querySelector('[name="category"]');
    const courseSelect = theForm.querySelector('[name="course"]');
    courseSelect.disabled = true;
    courseSelect.innerHTML = '<option value="" selected="selected" disabled="disabled">Select Course</option>';

    // populate state dropdown
    let categories = '<option value="" selected="selected" disabled="disabled">Select Category</option>';
    for (let key of Object.keys(coursesMap)) {
      categories = categories + `<option value="${key}">${key}</option>`;
    }
    categorySelect.innerHTML = categories;

    // listen for change events on the state dropdown
    categorySelect.addEventListener('change', function () {
      courseSelect.disabled = false;
      findCourseForm.populateCourses(theForm, this.value);
    });
  },

  populateCourses: function (theForm, category) {
    const courseSelect = theForm.querySelector('[name="course"]');
    const courses = coursesMap[category];
    let courseOptions = '<option value="" selected="selected" disabled="disabled">Select Course</option>';

    // populate category dropdown
    let courseCount = 0;
    for (let [key, value] of Object.entries(courses)) {
      if (value) {
        courseOptions = courseOptions + `<option value="${value}">${key}</option>`;
        courseCount++;
      }
    }
    courseSelect.innerHTML = courseOptions;

    // listen for change events on the state dropdown
    courseSelect.addEventListener('change', function () {
      // update the form's action with the url
      theForm.action = this.value;
    });

    // If only one course option, automatically select it
    if (courseCount === 1) {
      const firstOption = courseSelect.options[1];
      if (firstOption) {
        courseSelect.value = firstOption.value;
        // Trigger the change event to update the form action
        courseSelect.dispatchEvent(new Event('change'));
      }
    }
  },

  validateOnBlur: function (theForm) {
    if (!theForm) return false;

    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      field.addEventListener(
        'blur',
        function (e) {
          const x = field.value;
          if (!x || x.trim() == '') {
            field.classList.add('is-invalid');
          } else {
            field.classList.remove('is-invalid');
          }
        },
        true
      );
    }
  },

  isFormValid: function (theForm) {
    if (!theForm) return false;

    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const x = field.value;
      if (!x || x.trim() == '') {
        field.classList.add('is-invalid');
        isFormValid = false;
      } else {
        field.classList.remove('is-invalid');
      }
    }
    return isFormValid;
  },
};

const coursesMap = {
  ['HAZWOPER Courses']: {
    ['40-Hour HAZWOPER']: '/course/40-hour-hazwoper-training/',
    ['24-Hour HAZWOPER']: '/course/osha-24-hour-hazwoper-training/',
    ['24-Hour HAZWOPER RCRA TSD Operations']: '/course/24-hour-hazwoper-rcra-tsd/',
    ['8-Hour HAZWOPER Supervisor']: '/course/hazwoper-8-hour-supervisor/',
    ['8-Hour HAZWOPER Annual Refresher']: '/course/8-hour-hazwoper/',
    ['8-Hour HAZWOPER Annual Engineers & Scientists Refresher']: '/course/8-hour-hazwoper-for-engineers-and-scientists/',
    ['8-Hour HAZWOPER Annual RCRA TSD Operations Refresher']: '/course/8-hour-hazwoper-annual-refresher-rcra-tsd/',
  },
  ['First Responder Courses']: {
    ['HAZWOPER First Responder Awareness']: '/course/hazwoper-first-responder-awareness/',
    ['HAZWOPER First Responder Operations']: '/course/hazwoper-first-responder-operations/',
    ['HAZMAT Technician']: '/course/hazmat-technician/',
    ['HAZMAT Specialist']: '/course/hazmat-specialist/',
    ['8 Hour HAZWOPER Incident Command']: '/course/hazwoper-hazmat-8-hour-incident-command/',
    ['HAZMAT Annual Technician Refresher']: '/course/hazmat-technician-refresher/',
  },
  ['DOT HAZMAT Courses']: {
    ['DOT Hazardous Materials Transportation']: '/course/dot-hazardous-materials-transportation/',
  },
  ['Hazardous Waste Courses']: {
    ['RCRA Hazardous Waste Generator']: '/course/rcra-hazardous-waste-generator-training/',
  },
  ['OSHA General Industry Courses']: {
    ['OSHA 10 Training']: '/course/osha-10-hour-training/',
    ['OSHA 30 Training']: '/course/osha-30-hour-training/',
    ['Bloodborne Pathogens']: '/course/bloodborne-pathogens/',
    ['Compressed Gas Cylinder Safety']: '/course/compressed-gas-cylinder-safety/',
    ['Confined Space Entry']: '/course/confined-space-entry/',
    ['Hazard Communication Standard and Global Harmonized System']: '/course/hazard-communication-hazcom/',
    ['Hydrogen Sulfide Safety']: '/course/hydrogen-sulfide-h2s-safety/',
    ['Laboratory Safety']: '/course/lab-safety/',
    ['Lead Awareness for General Industry']: '/course/lead-awareness/',
    ['Lockout/Tagout']: '/course/lockout-tagout/',
    ['Personal Protective Equipment']: '/course/personal-protective-equipment/',
  },
  ['OSHA Construction Courses']: {
    ['Asbestos Awareness']: '/course/asbestos-awareness/',
    ['Competent Person for Excavation Trenching and Shoring']: '/course/excavation-trenching-and-shoring/',
    ['Competent Person for Fall Protection']: '/course/fall-protection-training/',
    ['Electrical Safety']: '/course/electrical-safety/',
    ['Lead Awareness for Construction']: '/course/lead-awareness-for-construction/',
    ['Stairway and Ladder Safety']: '/course/ladder-safety/',
  },
  ['Cursos de Español']: {
    ['40 horas de HAZWOPER']: '/course/spanish-40-hour-hazwoper/',
    ['24 horas de HAZWOPER']: '/course/spanish-24-hour-hazwoper/',
    ['Actualización anual de 8 horas de HAZWOPER']: '/course/spanish-8-hour-hazwoper-refresher/',
  },
};
